/**
 * Calendario Page - Page Shell
 * Visualizzazione calendario prenotazioni
 */

import { CalendarioList } from "@/features/calendario";

export default function Calendario() {
  return <CalendarioList />;
}
